webpackJsonp([1],{

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AnswerScreen__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AnswerScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AnswerScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_root_url__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_root_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_root_url__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Root',
    redirect: '/choose/manager'
  }, {
    path: '/choose/:item',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a,
    props: true
  }, {
    path: '/answer',
    name: 'Answer',
    component: __WEBPACK_IMPORTED_MODULE_2__components_AnswerScreen___default.a
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Admin___default.a
  }]
}));

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_navigation__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_root_url__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_root_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config_root_url__);












__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var logActivity = "production" === 'development' || true;

var log = function log(logContent) {
  if (logActivity) {
    var _console;

    var logTextContent = logContent;
    var logObjContent = null;
    if (typeof logContent === 'object' && logContent !== null) {
      logObjContent = logContent;
      logTextContent = '';
    }
    // console.log(logContent, typeof logContent);
    var logItem = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('DD/MM/YY HH:mm') + ' - ' + logTextContent;
    var dbLogItem = logItem;
    var consoleParams = [logItem];
    if (logObjContent !== null) {
      // dbLogItem = [logItem, logObjContent];
      dbLogItem += '[Object object]';
      consoleParams.push(logObjContent);
    }
    var dbLogs = JSON.parse(localStorage.getItem('weview_logs') || '[]');
    dbLogs.push(dbLogItem);
    localStorage.setItem('weview_logs', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(dbLogs));
    (_console = console).log.apply(_console, consoleParams);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  modules: {
    navigation: __WEBPACK_IMPORTED_MODULE_8__modules_navigation__["a" /* default */]
  },
  state: {
    token: null,
    tabletId: null,
    online: false, // tablet is online ?
    authenticated: null,
    api: null, // axios instance to query API
    weviewObject: null, // all data from weview (managers, surveysStarts, participants...)
    currentParticipant: null, // used in answer screen
    currentSurvey: null, // ''
    currentManager: null,
    currentSurveyStart: null,
    stagedAnswers: [], // answers to submit while online
    lastConnectionDate: null,
    lastRemoteUpdate: __WEBPACK_IMPORTED_MODULE_7_moment___default()(0), // date of last update from the server, used to check if we should update
    lastLocalUpdate: __WEBPACK_IMPORTED_MODULE_7_moment___default()(0), // date of last update successfuly received from the server
    isUpdating: false,
    dataExpired: false, // if date is expired, lock tablet until is updated
    lastServiceWorkerCheck: __WEBPACK_IMPORTED_MODULE_7_moment___default()(),
    currentQuestion: null
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('weview_token', token);
    },
    SET_ID_TABLET: function SET_ID_TABLET(state, id) {
      state.tabletId = id;
      localStorage.setItem('weview_tablet_id', id);
    },
    SET_ONLINE: function SET_ONLINE(state, online) {
      state.online = online;
    },
    SET_AUTHENTICATED: function SET_AUTHENTICATED(state, authenticated) {
      state.authenticated = authenticated;
    },
    SET_IS_UPDATING: function SET_IS_UPDATING(state, updating) {
      state.isUpdating = updating;
    },
    LOAD_TOKEN: function LOAD_TOKEN(state) {
      state.token = localStorage.getItem('weview_token');
    },
    LOAD_TABLET_ID: function LOAD_TABLET_ID(state) {
      state.tabletId = localStorage.getItem('weview_tablet_id');
    },
    LOAD_WEVIEW_OBJECT: function LOAD_WEVIEW_OBJECT(state) {
      state.weviewObject = JSON.parse(localStorage.getItem('weview_object'));
    },
    LOAD_STAGED_ANSWERS: function LOAD_STAGED_ANSWERS(state) {
      var textData = localStorage.getItem('weview_staged_answers');
      if (textData) {
        state.stagedAnswers = JSON.parse(textData);
      }
    },
    FORGE_API_INSTANCE: function FORGE_API_INSTANCE(state) {
      state.api = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
        headers: { 'X-Tablet-Token': state.token }
      });
    },
    SET_WEVIEW_OBJECT: function SET_WEVIEW_OBJECT(state, weviewObject) {
      state.weviewObject = weviewObject;
      localStorage.setItem('weview_object', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.weviewObject));
    },
    SAVE_WEVIEW_OBJECT: function SAVE_WEVIEW_OBJECT(state) {
      localStorage.setItem('weview_object', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.weviewObject));
    },
    SET_CURRENT_PARTICIPANT: function SET_CURRENT_PARTICIPANT(state, participant) {
      log('setting current particpant', participant);
      state.currentParticipant = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(participant);
    },
    SET_CURRENT_SURVEY: function SET_CURRENT_SURVEY(state, survey) {
      state.currentSurvey = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(survey);
      if (survey) {
        var i = 0;
        state.currentSurvey.questions.forEach(function (q) {
          return q.index = i++;
        });
      }
    },
    SET_CURRENT_MANAGER: function SET_CURRENT_MANAGER(state, manager) {
      state.currentManager = manager;
    },
    SET_CURRENT_SURVEYSTART: function SET_CURRENT_SURVEYSTART(state, surveyStart) {
      state.currentSurveyStart = surveyStart;
    },
    SAVE_CURRENT_ANSWERS: function SAVE_CURRENT_ANSWERS(state) {
      // participant has answered all question, saving them...
      // state.currentParticipant.hasAnswered = true; // doesnt work because currentParticipant is a copy
      if (state.currentParticipant.isAdditionnal) {
        var additionnalParticipant = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.currentParticipant);
        additionnalParticipant.hasAnswered = true;
        additionnalParticipant.isAdditionnal = false;
        additionnalParticipant.employee = null;
        state.navigation.currentSurveyStart.participants.push(additionnalParticipant);
      } else {
        var participant = state.currentSurveyStart.participants.find(function (p) {
          return p.id === state.currentParticipant.id;
        });
        participant.hasAnswered = true;
      }
      // stage :
      // (adding id to use when sending answers)
      var answersItem = { participant: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.currentParticipant), survey: state.currentSurvey, _id: __WEBPACK_IMPORTED_MODULE_9_uuid___default.a.v4() };
      var historyAnswers = JSON.parse(localStorage.getItem('weview_history_answers') || '[]');
      state.stagedAnswers.push(answersItem);
      historyAnswers.push(answersItem);
      // save :
      localStorage.setItem('weview_staged_answers', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.stagedAnswers));
      localStorage.setItem('weview_history_answers', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(historyAnswers));
      localStorage.setItem('weview_object', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.weviewObject));

      // reset current:
      state.currentParticipant = null;
      state.currentSurvey = null;
    },
    CLEAR_STAGED_DATA: function CLEAR_STAGED_DATA(state, participantTabletIds) {
      // unstaging sent answers :
      log('unstaging sent answers...');
      participantTabletIds.forEach(function (participantTabletId) {
        var index = state.stagedAnswers.findIndex(function (sa) {
          return sa._id === participantTabletId;
        }); // _id set in SAVE_CURRENY_ANSWERS
        if (index > -1) {
          state.stagedAnswers.splice(index, 1); // actually unstaging
        }
      });
      log('unstaged answers (' + state.stagedAnswers.length + ' remaining)');
      // state.stagedAnswers = [];
      localStorage.setItem('weview_staged_answers', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.stagedAnswers));
    },
    RESET_CURRENTS: function RESET_CURRENTS(state) {
      state.currentSurvey = null;
      state.currentParticipant = null;
      state.currentManager = null;
      state.currentSurveyStart = null;
    },
    SAVE_LAST_CONNECTION_DATE: function SAVE_LAST_CONNECTION_DATE(state) {
      state.lastConnectionDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
    },
    SAVE_REMOTE_UPDATE: function SAVE_REMOTE_UPDATE(state, update) {
      state.lastRemoteUpdate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(update);
    },
    SAVE_LOCAL_UPDATE: function SAVE_LOCAL_UPDATE(state, update) {
      state.lastLocalUpdate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(update);
    },
    SET_UPDATE_DATES_UPDATED: function SET_UPDATE_DATES_UPDATED(state) {
      state.lastLocalUpdate = state.lastRemoteUpdate.clone();
    },
    CHECK_EXPIRATION: function CHECK_EXPIRATION(state) {
      log('checking expiration date...');
      if (state.lastConnectionDate && state.lastConnectionDate.clone().add(3, 'day').isBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()())) {
        state.dataExpired = true;
        log('data is too old, locking tablet...');
      } else {
        state.dataExpired = false;
        log('data is viable');
      }
    },
    SAVE_SERVICEWORKER_CHECK_DATE: function SAVE_SERVICEWORKER_CHECK_DATE(state) {
      state.lastServiceWorkerCheck = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
    },
    UPDATE_ALL_DELAY: function UPDATE_ALL_DELAY(state, timeout) {
      state.updateAllTimeout = timeout;
    },
    CANCEL_UPDATE_ALL_DELAY: function CANCEL_UPDATE_ALL_DELAY(state) {
      clearTimeout(state.updateAllTimeout);
    },
    SET_CURRENT_QUESTION: function SET_CURRENT_QUESTION(state, question) {
      state.currentQuestion = question;
    },
    SET_ADDITIONAL_ANSWER: function SET_ADDITIONAL_ANSWER(state, newAnswer) {
      state.currentQuestion.additionalAnswer = newAnswer;
    }
  },
  actions: {
    updateServiceWorker: function updateServiceWorker(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // eslint-disable-line
      log('update service worker ?');
      var shouldUpdate = force || state.lastServiceWorkerCheck.clone().add(30, 'minutes').isBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()());
      if ('serviceWorker' in navigator && "production" === 'production' && shouldUpdate) {
        log('serviceworker update needed');
        return navigator.serviceWorker.getRegistration(__WEBPACK_IMPORTED_MODULE_10__config_root_url___default.a + '/').then(function (reg) {
          log(reg);
          if (!reg) {
            log('enable to get service worker registration');
            return null;
          }

          log('checking for serviceworker update.....');
          commit('SAVE_SERVICEWORKER_CHECK_DATE');
          return reg.update();
        });
      }

      log('no need to update serviceworker, last check too recent');
      return null;
    },
    resetTablet: function resetTablet(_ref2) {
      var dispatch = _ref2.dispatch;

      log('Reseting tablet ...');
      localStorage.removeItem('weview_token');
      localStorage.removeItem('weview_tablet_id');
      localStorage.removeItem('weview_staged_answers');
      localStorage.removeItem('weview_object');
      dispatch('init').then(function () {
        return log('reset process finished');
      });
    },
    connect: function connect(_ref3, code) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      log('connecting... ' + code);
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/api/tablets/connect', { connectionCode: code }).then(function (res) {
        log('connected successfuly');
        log(res);
        localStorage.removeItem('weview_token');
        localStorage.removeItem('weview_tablet_id');
        localStorage.removeItem('weview_staged_answers');
        localStorage.removeItem('weview_object');
        commit('SET_TOKEN', res.data.token);
        commit('SET_ID_TABLET', res.data.id);
        dispatch('init');
      }).catch(function (err) {
        log('erreur de connection');
        log(err);
      });
    },
    sendDiag: function sendDiag(_ref4) {
      var state = _ref4.state;

      var weviewObject = JSON.parse(localStorage.getItem('weview_object') || '{}');
      if (weviewObject.managers && weviewObject.managers.length) {
        weviewObject.managers = weviewObject.managers.map(function (manager) {
          var surveyStarts = manager.surveyStarts.map(function (surveyStart) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, surveyStart, {
              participants: 'property deleted for logs weight'
            });
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, manager, {
            surveyStarts: surveyStarts
          });
        });
      }
      var diagContent = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        weview_token: localStorage.getItem('weview_token') || '',
        weview_object: weviewObject,
        weview_tablet_id: localStorage.getItem('weview_tablet_id') || '',
        weview_staged_answers: JSON.parse(localStorage.getItem('weview_staged_answers') || '[]'),
        weview_history_answers: JSON.parse(localStorage.getItem('weview_history_answers') || '[]'),
        weview_logs: JSON.parse(localStorage.getItem('weview_logs') || '[]')
      });
      return state.api.post('/api/tablets/diagnostic-report', { content: diagContent });
    },

    // test connection and tell us if we can update
    testConnection: function testConnection(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;

      if (!state.token || !state.tabletId) {
        log('No token or tablet ID');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
      }
      log('pinging server...');

      return state.api.get('/api/tablets/' + state.tabletId + '/check').then(function (res) {
        log('connected, update', res.data.update);
        commit('SAVE_REMOTE_UPDATE', res.data.update);
        commit('SET_AUTHENTICATED', true);
        commit('SET_ONLINE', true);
        return true;
      }).catch(function (err) {
        log(err);
        if (err.response && (err.response.status === 400 || err.response.status === 401)) {
          log('Server error, wrong id or token ?');
          //  token + id rejected
          commit('SET_AUTHENTICATED', false);
          commit('SET_ONLINE', true);
          return false;
        }

        log('app is offline');
        commit('SET_ONLINE', false);
        return false;
      });
    },
    saveCurrentAnswers: function saveCurrentAnswers(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('SAVE_CURRENT_ANSWERS');
      commit('RESET_CURRENTS');

      return dispatch('updateAll');
    },
    init: function init(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      log('initializing store...');
      commit('LOAD_TOKEN');
      commit('LOAD_TABLET_ID');
      commit('LOAD_WEVIEW_OBJECT');
      commit('LOAD_STAGED_ANSWERS');
      commit('SET_CURRENT_SURVEY', null);
      commit('SET_CURRENT_PARTICIPANT', null);

      commit('FORGE_API_INSTANCE');

      return dispatch('updateAll', true);
    },
    changeOnlineStatus: function changeOnlineStatus(_ref8, online) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      log('Online status has changed to:');
      log(online);
      if (online) {
        log('Internet connection probably acquired, trigger update....');
        dispatch('triggerUpdate');
      }
      commit('SET_ONLINE', online);
    },
    triggerUpdate: function triggerUpdate(_ref9) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;

      log('update triggered');

      commit('CHECK_EXPIRATION');

      return dispatch('updateAll');
    },
    updateAll: function updateAll(_ref10) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit,
          state = _ref10.state;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (state.isUpdating) return null;
      commit('CANCEL_UPDATE_ALL_DELAY');
      commit('SET_IS_UPDATING', true);

      return dispatch('testConnection').then(function (ok) {
        if (!ok) {
          commit('SET_IS_UPDATING', false);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('update process can\'t be started');
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }).then(function () {
        return dispatch('sendAllAnswers');
      }).then(function () {
        return commit('SAVE_LAST_CONNECTION_DATE');
      }).then(function () {
        return commit('CHECK_EXPIRATION');
      })
      // .then(() => dispatch(`testConnection`))
      .then(function () {
        if (force || state.dataExpired || state.lastRemoteUpdate.isAfter(state.lastLocalUpdate)) {
          log('update needed' + (force ? ' (forced)' : ''));
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('no need to update, local and remote date ok');
      }).then(function () {
        return dispatch('updateWeviewObject');
      }).then(function () {
        return commit('SET_UPDATE_DATES_UPDATED');
      }).then(function () {
        return commit('SET_IS_UPDATING', false);
      }).catch(function (err) {
        log(err);
        commit('SET_IS_UPDATING', false);
        commit('CHECK_EXPIRATION');
      }).then(function () {
        return dispatch('delayUpdateAllIfNeeded');
      }).then(function () {
        return dispatch('updateServiceWorker', force);
      });
    },
    updateWeviewObject: function updateWeviewObject(_ref11) {
      var commit = _ref11.commit,
          state = _ref11.state;

      log('updating weview data from server...');
      return state.api.get('/api/tablets/' + state.tabletId + '/config').then(function (response) {
        log(response.data);
        commit('SET_WEVIEW_OBJECT', response.data);
        log('data updated');
      }).catch(function (err) {
        log(err);
      });
    },
    delayUpdateAllIfNeeded: function delayUpdateAllIfNeeded(_ref12) {
      var commit = _ref12.commit,
          state = _ref12.state,
          dispatch = _ref12.dispatch;

      if (state.stagedAnswers.length || state.dataExpired) {
        commit('UPDATE_ALL_DELAY', setTimeout(function () {
          return dispatch('updateAll', true);
        }, 5000));
      }
    },
    sendAllAnswers: function sendAllAnswers(_ref13) {
      var commit = _ref13.commit,
          state = _ref13.state,
          dispatch = _ref13.dispatch;

      log('sending staged answers...');
      if (state.stagedAnswers.length === 0) {
        log('no answer to send');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      var sendingAnswers = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(state.stagedAnswers).map(function (answers) {
        __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(answers.survey.questions, function (question) {
          return Boolean(question.questionnaire);
        }).forEach(function (question) {
          if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isArray(question.additionalAnswer)) {
            question.additionalAnswer = question.additionalAnswer.join(', ');
          }
        });
        return answers;
      });

      return state.api.post('/api/tablets/' + state.tabletId + '/answers', sendingAnswers).then(function (res) {
        log('answers sent successfuly');
        log(res);
        if (res.status === 200 && res.data.success) {
          commit('CLEAR_STAGED_DATA', res.data.participantTabletIds);
          return dispatch('testConnection');
        }
      }).catch(function (e) {
        log('answers not sent');
        log(e);
      });
    }
  }
}));

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
  __webpack_require__(295)
  __webpack_require__(296)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      drawer: null,
      items: [{ title: 'Home', icon: 'dashboard' }, { title: 'About', icon: 'question_answer' }],
      mini: false,
      right: null
    };
  },

  methods: {
    init: function init() {
      return this.$store.dispatch('init');
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])(['online']),
  mounted: function mounted() {
    return this.init();
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "admin",
  data: function data() {
    return {
      password: ""
    };
  },

  methods: {
    reset: function reset() {
      var _this = this;

      this.$store.dispatch("resetTablet").then(function () {
        _this.$router.push({ name: "Home" });
      });
    },
    back: function back() {
      this.$router.push({ name: "Home" });
    }
  },
  computed: {
    isAdmin: function isAdmin() {
      return this.$store.state.weviewObject ? this.password === this.$store.state.weviewObject.adminCode : false;
    }
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__additional_Question__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__additional_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__additional_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'answerscreen',
  components: {
    Question: __WEBPACK_IMPORTED_MODULE_4__additional_Question___default.a
  },
  data: function data() {
    return {
      isSubmitting: false,
      isFailed: false,
      isSucceeded: false,
      currentScore: null,
      currentVerbatim: '',
      maxVerbatimLength: 250,
      submited: false
    };
  },
  mounted: function mounted() {
    this.currentQuestion = null;
  },

  methods: {
    getCategory: function getCategory(question) {
      return Boolean(question.data) && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isInteger(question.data.category) ? this.survey.$scopQuestionnaire.data.categories[question.data.category] : null;
    },
    start: function start() {
      this.currentQuestion = this.survey.questions[0];
    },
    nextQuestion: function nextQuestion() {
      var _this = this;

      var nextQuestionIndex = this.survey.questions.indexOf(this.currentQuestion) + 1;
      if (nextQuestionIndex >= this.survey.questions.length) {
        return this.submitSurvey();
      }
      var canContinue = false;
      if (this.currentQuestion.questionnaire && this.currentQuestion.data.skipAdditionnalQuestionnaireIf && this.currentQuestion.additionalAnswer === this.currentQuestion.data.choices[this.currentQuestion.data.skipAdditionnalQuestionnaireIf]) {
        this.currentQuestion = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.survey.questions, function (q) {
          return !q.questionnaire;
        });
        return;
      }
      this.currentQuestion = this.survey.questions[nextQuestionIndex];
      if (this.currentQuestion.questionnaire && this.currentQuestion.data.conditions && this.currentQuestion.data.conditions.length > 0) {
        var _loop = function _loop(condition) {
          var conditionQuestion = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(_this.currentSurvey.questions, { id: condition.question });
          if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(conditionQuestion.additionalAnswer)) {
            if (conditionQuestion.data.otherChoice && condition.answerIndex === conditionQuestion.data.choices.length) {
              if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(conditionQuestion.additionalAnswer, function (answer) {
                return answer.split(' :')[0] === conditionQuestion.data.otherLabel;
              })) {
                canContinue = true;
              }
            }
            if (conditionQuestion.additionalAnswer.includes(conditionQuestion.data.choices[condition.answerIndex])) {
              canContinue = true;
            }
          } else {
            if (conditionQuestion.data.otherChoice && condition.answerIndex === conditionQuestion.data.choices.length) {
              if (conditionQuestion.additionalAnswer.split(' :')[0] === conditionQuestion.data.otherLabel) {
                canContinue = true;
              }
            }
            if (conditionQuestion.additionalAnswer === conditionQuestion.data.choices[condition.answerIndex]) {
              canContinue = true;
            }
          }
          if (!canContinue) {
            return {
              v: _this.nextQuestion()
            };
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.currentQuestion.data.conditions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var condition = _step.value;

            var _ret = _loop(condition);

            if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    confirmAnswer: function confirmAnswer() {
      this.currentQuestion.score = this.currentScore;
      this.currentScore = null;
      this.nextQuestion();
      return null;
    },
    answer: function answer(score) {
      this.currentScore = score;
    },
    answerVerbatim: function answerVerbatim() {
      this.currentQuestion.verbatim = this.currentVerbatim;
      this.currentVerbatim = '';
      this.confirmAnswer();
    },
    submitSurvey: function submitSurvey() {
      this.$store.dispatch('saveCurrentAnswers');
      this.submited = true;
    },
    goToHome: function goToHome() {
      this.$router.replace('/choose/participant');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    participant: 'currentParticipant',
    survey: 'currentSurvey',
    rawCurrentQuestion: 'currentQuestion',
    currentSurvey: 'currentSurvey',
    stagedAnswers: 'stagedAnswers'
  }), {
    currentQuestion: {
      get: function get() {
        return this.rawCurrentQuestion;
      },
      set: function set(question) {
        this.$store.commit('SET_CURRENT_QUESTION', question);
      }
    }
  })
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navigation__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  props: ['company', 'item'],
  data: function data() {
    return {
      connectionCode: '',
      drawer: null,
      connectionDialog: null,
      showMoreInMenu: false,
      confirmSendDiag: false,
      isSendingDiag: false
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // ne pas aller vers la selection du diag ou du participant si on pas les données pour
    if (to.path === '/choose/survey' && !this.$store.state.navigation.currentManager) {
      return;
    } else if (to.path === '/choose/participant' && (!this.$store.state.navigation.currentManager || !this.$store.state.navigation.currentSurveyStart)) {
      return;
    }
    next();
  },

  components: { Navigation: __WEBPACK_IMPORTED_MODULE_3__Navigation___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    tabletName: function tabletName() {
      if (this.$store.state.weviewObject && this.$store.state.weviewObject.tabletName) {
        return this.$store.state.weviewObject.tabletName;
      }

      return '';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['isUpdating', 'token', 'tabletId', 'dataExpired', 'online', 'stagedAnswers', 'isUpdating', 'authenticated']), {
    version: function version() {
      return "1.2.0";
    }
  }),
  methods: {
    connect: function connect() {
      this.$store.dispatch('connect', this.connectionCode);
      this.connectionDialog = false;
    },
    update: function update() {
      this.$store.dispatch('updateAll', true);
    },
    goToAdmin: function goToAdmin() {
      this.$router.push({ name: 'Admin' });
    },
    reload: function reload() {
      document.location.reload(true);
    },
    sendDiag: function sendDiag() {
      if (this.isSendingDiag || !this.online) {
        return;
      }
      this.drawer = false;
      this.confirmSendDiag = true;
    },
    processSendDiag: function processSendDiag() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isSendingDiag = true;
                _context.next = 3;
                return _this.$store.dispatch('sendDiag');

              case 3:
                _this.confirmSendDiag = false;
                setTimeout(function () {
                  _this.isSendingDiag = false;
                }, 250);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reloadApp: function reloadApp() {
      if (!this.online) {
        return;
      }
      this.$router.push({ name: 'Root' });
      setTimeout(function () {
        return document.location.reload(true);
      });
    },
    toggleShowMoreInMenu: function toggleShowMoreInMenu() {
      this.showMoreInMenu = !this.showMoreInMenu;
    }
  },
  watch: {
    drawer: function drawer() {
      if (!this.drawer) {
        this.showMoreInMenu = false;
      }
    }
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      teamFilter: 'all'
    };
  },

  props: ['currentMenu'],
  methods: {
    moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a,
    goBackToManagerChoice: function goBackToManagerChoice() {
      this.$router.push('/choose/manager');
      this.currentManager = null;
      this.currentSurveyStart = null;
    },
    goBackToSurveyChoice: function goBackToSurveyChoice() {
      if (this.currentManager.surveyStarts && this.currentManager.surveyStarts.length === 1) {
        this.goBackToManagerChoice();
        return;
      }

      this.$router.push('/choose/survey');
    },
    chooseManager: function chooseManager(manager) {
      this.currentManager = manager;
      if (manager.surveyStarts && manager.surveyStarts.length === 1) {
        var ss = manager.surveyStarts[0];
        this.chooseSurveyStart(ss);
        return;
      }
      this.$router.push('/choose/survey');
    },
    chooseSurveyStart: function chooseSurveyStart(surveyStart) {
      this.currentSurveyStart = surveyStart;
      this.teamFilter = 'all';
      // this.currentMenu        = `participant`;
      this.$router.push('participant');
    },
    chooseParticipant: function chooseParticipant(participant) {
      var _this = this;

      if (!participant.isAdditionnal && (participant.hasAnswered || participant.isDone)) return;

      var survey = this.$store.state.weviewObject.surveys.find(function (su) {
        return su.id === _this.currentSurveyStart.survey.id;
      });
      if (participant.answerSlave) {
        if (!survey.questions.find(function (q) {
          return q.id === survey.slaveQuestions[0].id;
        })) {
          var _survey$questions;

          (_survey$questions = survey.questions).push.apply(_survey$questions, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(survey.slaveQuestions));
        }
      } else {
        if (survey.questions.find(function (q) {
          return q.id === survey.questions[0].id;
        })) {
          survey.questions = survey.questions.filter(function (q) {
            return !survey.slaveQuestions.find(function (sq) {
              return sq.id === q.id;
            });
          });
        }
      }
      this.$store.commit('SET_CURRENT_PARTICIPANT', participant);
      this.$store.commit('SET_CURRENT_SURVEY', survey);
      this.$store.commit('SET_CURRENT_MANAGER', this.currentManager);
      this.$store.commit('SET_CURRENT_SURVEYSTART', this.currentSurveyStart);
      this.teamFilter = 'all';
      this.$router.push({ name: 'Answer' });
    },
    chooseNextMergedParticipant: function chooseNextMergedParticipant(nodeId) {
      if (this.nextMergedParticipants[nodeId] && this.nextMergedParticipants[nodeId].nbLeft === 0) return;

      var participant = this.currentSurveyStart.participants.find(function (p) {
        return !p.isDone && !p.isAdditionnal && !p.hasAnswered && p.isMerged && p.node.id === nodeId;
      });
      if (!participant) {
        return;
      }

      return this.chooseParticipant(participant);
    },
    updateCurrents: function updateCurrents() {
      var _this2 = this;

      if (this.currentManager) {
        var newManagerObj = this.managers.find(function (m) {
          return m.id === _this2.currentManager.id;
        });
        this.currentManager = newManagerObj;

        if (this.currentSurveyStart) {
          if (!newManagerObj.surveyStarts) {
            // surveystart was finished/close remotly, go back
            this.goBackToSurveyChoice();
            return;
          }
          var newSurveyStartObj = newManagerObj.surveyStarts.find(function (ss) {
            return ss.id === _this2.currentSurveyStart.id;
          });
          this.currentSurveyStart = newSurveyStartObj;
        }
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    additionnalParticipants: function additionnalParticipants() {
      var _this3 = this;

      var additionnalParticipants = [];
      if (this.onTheFly) {
        this.currentSurveyStart.participants.forEach(function (participant) {
          if (!additionnalParticipants.find(function (p) {
            return p.node.id === participant.node.id;
          }) && (!_this3.nextMergedParticipants[participant.node.id] || _this3.nextMergedParticipants[participant.node.id] && _this3.nextMergedParticipants[participant.node.id].nbLeft === 0)) {
            var additionnalParticipant = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(participant);
            additionnalParticipant.isAdditionnal = true;
            additionnalParticipant.isFly = true;
            additionnalParticipants.push(additionnalParticipant);
          }
        });
      }

      return additionnalParticipants.filter(function (p) {
        return p.node.id === _this3.teamFilter || _this3.teamFilter === 'all';
      });
    },
    currentParticipants: function currentParticipants() {
      var _this4 = this;

      var currentParticipants = this.currentSurveyStart.participants.filter(function (p) {
        return p.employee;
      });

      currentParticipants.sort(function (a, b) {
        var scoreA = 0;
        var scoreB = 0;
        if (a.isDone || a.hasAnswered) scoreA += 400;
        if (b.isDone || b.hasAnswered) scoreB += 400;
        if (a.employee) scoreA += 150;
        if (b.employee) scoreB += 150;
        if (a.employee && b.employee && a.employee.firstname.localeCompare(b.employee.firstname) > 0) scoreA += 50;else scoreB += 50;

        return scoreA - scoreB;
      });

      // filter to only display selected teams:
      return currentParticipants.filter(function (p) {
        return p.node.id === _this4.teamFilter || _this4.teamFilter === 'all';
      });
    },
    nextMergedParticipants: function nextMergedParticipants() {
      var _this5 = this;

      var nextMergedParticipants = {};

      this.currentSurveyStart.participants.forEach(function (participant) {
        // if (!participant.isMerged && participant.employee) { return; }
        if (participant.employee && !participant.isAdditionnal) {
          return;
        }
        if (nextMergedParticipants[participant.node.id]) {

          nextMergedParticipants[participant.node.id].nbDone += participant.isDone || participant.hasAnswered ? 1 : 0;
          nextMergedParticipants[participant.node.id].nbLeft += participant.isDone || participant.hasAnswered ? 0 : 1;
          nextMergedParticipants[participant.node.id].nbTotal += !participant.isFly ? 1 : 0;
        } else {
          nextMergedParticipants[participant.node.id] = {
            nbDone: participant.isDone || participant.hasAnswered ? 1 : 0,
            nbLeft: participant.isDone || participant.hasAnswered ? 0 : 1,
            nbTotal: !participant.isFly ? 1 : 0,
            node: participant.node
          };
        }
      });

      // filter to only display selected teams :
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(nextMergedParticipants).forEach(function (nodeId) {
        if (_this5.teamFilter !== 'all' && nodeId !== _this5.teamFilter) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default()(nextMergedParticipants, nodeId);
        }
      });

      return nextMergedParticipants;
    },
    currentPossibleNodes: function currentPossibleNodes() {
      var nodes = { all: 'Toutes les \xE9quipes' };
      this.currentSurveyStart.participants.forEach(function (participant) {
        if (!nodes[participant.node.id]) {
          nodes[participant.node.id] = participant.node.label;
        }
      });

      return nodes;
    },

    currentManager: {
      get: function get() {
        return this.$store.state.navigation.currentManager;
      },
      set: function set(newVal) {
        this.$store.commit('NAV_SET_CURRENT_MANAGER', newVal);
      }
    },
    currentSurveyStart: {
      get: function get() {
        return this.$store.state.navigation.currentSurveyStart;
      },
      set: function set(surveyStart) {
        this.$store.commit('NAV_SET_CURRENT_SURVEYSTART', surveyStart);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['isUpdating']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    managers: function managers(state) {
      if (state && state.weviewObject) {
        return state.weviewObject.managers;
      }
      return [];
    },
    onTheFly: function onTheFly(state) {
      if (state && state.weviewObject && state.weviewObject.settings) {
        return state.weviewObject.settings.onTheFly || false;
      }

      return false;
    }
  })),

  watch: {
    managers: {
      deep: true,
      handler: function handler() {
        this.updateCurrents();
      }
    }
  }

});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MultiChoice",
  data: function data() {
    return {
      answers: [],
      comment: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['currentQuestion'])),
  methods: {
    clear: function clear() {
      this.answers = [];
      this.comment = null;
    }
  },
  watch: {
    answers: function answers(newAnswers) {
      var canValidate = newAnswers.length > 0;
      if (newAnswers.includes(this.currentQuestion.data.otherLabel)) {
        canValidate = canValidate && Boolean(this.comment);
        var otherAnswer = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(newAnswers, this.currentQuestion.data.otherLabel);
        otherAnswer = otherAnswer + ' : ' + this.comment;
      } else {
        this.comment = '';
      }
      this.$emit('canValidate', canValidate);
      this.$emit('newAnswer', newAnswers);
    },
    comment: function comment(newComment) {
      if (this.answers.includes(this.currentQuestion.data.otherLabel)) {
        var answers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.answers));
        var otherAnswer = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(answers, this.currentQuestion.data.otherLabel)[0];
        otherAnswer = otherAnswer + ' : ' + this.comment;
        answers.push(otherAnswer);
        this.$emit('canValidate', Boolean(newComment));
        this.$emit('newAnswer', answers);
      }
    }
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Order",
  data: function data() {
    return {
      answers: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentQuestion'])),
  methods: {
    clear: function clear() {
      this.answers = {};
    },
    selectChanged: function selectChanged(num, event) {
      this.answers[num] = event;
      var sameAnswer = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findKey(this.answers, function (answer, key) {
        return answer === event && Number(key) !== Number(num);
      });
      if (sameAnswer) {
        this.answers[sameAnswer] = null;
      }
      this.$forceUpdate();
      var valid = this.currentQuestion.data.sortCount === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.answers).length;
      if (valid) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.answers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var answer = _step.value;

            valid &= Boolean(answer);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.$emit('canValidate', valid);
      this.$emit('newAnswer', __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(this.answers, function (answer, key) {
        return 'Choix ' + key + ' : ' + answer;
      }).join(', '));
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Verbatim__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Verbatim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Verbatim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultiChoice__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultiChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MultiChoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleChoice__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SingleChoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Order__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Order__);

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Question",
  data: function data() {
    return {
      canValidate: false,
      currentAnswer: null
    };
  },
  components: {
    Verbatim: __WEBPACK_IMPORTED_MODULE_2__Verbatim___default.a,
    MultiChoice: __WEBPACK_IMPORTED_MODULE_3__MultiChoice___default.a,
    SingleChoice: __WEBPACK_IMPORTED_MODULE_4__SingleChoice___default.a,
    Order: __WEBPACK_IMPORTED_MODULE_5__Order___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['currentQuestion', 'currentSurvey'])),
  methods: {
    newAnswerChanged: function newAnswerChanged(newAnswer) {
      this.currentAnswer = newAnswer;
    },
    canValidateChanged: function canValidateChanged(canValidate) {
      this.canValidate = canValidate;
    },
    next: function next() {
      this.$store.commit('SET_ADDITIONAL_ANSWER', this.currentAnswer);
      this.$refs[this.currentQuestion.data.type].clear();
      this.$emit('next');
      this.currentAnswer = null;
      this.canValidate = false;
    }
  }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SingleChoice",
  data: function data() {
    return {
      answer: null,
      comment: ""
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(["currentQuestion"])),
  methods: {
    clear: function clear() {
      this.answer = null;
      this.comment = null;
    }
  },
  watch: {
    answer: function answer(newAnswer) {
      var canValidate = Boolean(newAnswer);
      if (newAnswer === this.currentQuestion.data.otherLabel) {
        canValidate = canValidate && Boolean(this.comment);
      } else {
        this.comment = "";
      }
      this.$emit("canValidate", canValidate);
      this.$emit("newAnswer", newAnswer);
    },
    comment: function comment(newComment) {
      if (this.answer === this.currentQuestion.data.otherLabel) {
        this.$emit("canValidate", Boolean(newComment));
        this.$emit("newAnswer", this.answer + " : " + newComment);
      }
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Verbatim",
  data: function data() {
    return {
      answer: ""
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(["currentQuestion"])),
  methods: {
    clear: function clear() {
      this.answer = "";
    }
  },
  watch: {
    answer: function answer(newAnswer) {
      this.$emit("canValidate", newAnswer.length > 0);
      this.$emit("newAnswer", newAnswer);
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polyfill_array_includes__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polyfill_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_polyfill_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ifvisible_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ifvisible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ifvisible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_root_url__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_root_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config_root_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_roboto_roboto_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_roboto_roboto_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_roboto_roboto_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
});

window.addEventListener('load', function () {
  var updateOnlineStatus = function updateOnlineStatus() {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('changeOnlineStatus', navigator.onLine);
  };

  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);

  __WEBPACK_IMPORTED_MODULE_6_ifvisible_js___default.a.on('wakeup', function () {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('triggerUpdate');
  });
});

window.setInterval(function () {
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('updateServiceWorker', true);
}, 1000 * 60 * 60 * 6); // every 6 hours

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    currentManager: null,
    currentSurveyStart: null
    // currentMenu        : `manager`,
  },
  mutations: {
    NAV_SET_CURRENT_MANAGER: function NAV_SET_CURRENT_MANAGER(state, manager) {
      state.currentManager = manager;
    },
    NAV_SET_CURRENT_SURVEYSTART: function NAV_SET_CURRENT_SURVEYSTART(state, surveyStart) {
      state.currentSurveyStart = surveyStart;
    },
    NAV_SET_CURRENT_MENU: function NAV_SET_CURRENT_MENU(state, menu) {
      state.currentMenu = menu;
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 75,
	"./af.js": 75,
	"./ar": 82,
	"./ar-dz": 76,
	"./ar-dz.js": 76,
	"./ar-kw": 77,
	"./ar-kw.js": 77,
	"./ar-ly": 78,
	"./ar-ly.js": 78,
	"./ar-ma": 79,
	"./ar-ma.js": 79,
	"./ar-sa": 80,
	"./ar-sa.js": 80,
	"./ar-tn": 81,
	"./ar-tn.js": 81,
	"./ar.js": 82,
	"./az": 83,
	"./az.js": 83,
	"./be": 84,
	"./be.js": 84,
	"./bg": 85,
	"./bg.js": 85,
	"./bn": 86,
	"./bn.js": 86,
	"./bo": 87,
	"./bo.js": 87,
	"./br": 88,
	"./br.js": 88,
	"./bs": 89,
	"./bs.js": 89,
	"./ca": 90,
	"./ca.js": 90,
	"./cs": 91,
	"./cs.js": 91,
	"./cv": 92,
	"./cv.js": 92,
	"./cy": 93,
	"./cy.js": 93,
	"./da": 94,
	"./da.js": 94,
	"./de": 97,
	"./de-at": 95,
	"./de-at.js": 95,
	"./de-ch": 96,
	"./de-ch.js": 96,
	"./de.js": 97,
	"./dv": 98,
	"./dv.js": 98,
	"./el": 99,
	"./el.js": 99,
	"./en-au": 100,
	"./en-au.js": 100,
	"./en-ca": 101,
	"./en-ca.js": 101,
	"./en-gb": 102,
	"./en-gb.js": 102,
	"./en-ie": 103,
	"./en-ie.js": 103,
	"./en-nz": 104,
	"./en-nz.js": 104,
	"./eo": 105,
	"./eo.js": 105,
	"./es": 107,
	"./es-do": 106,
	"./es-do.js": 106,
	"./es.js": 107,
	"./et": 108,
	"./et.js": 108,
	"./eu": 109,
	"./eu.js": 109,
	"./fa": 110,
	"./fa.js": 110,
	"./fi": 111,
	"./fi.js": 111,
	"./fo": 112,
	"./fo.js": 112,
	"./fr": 115,
	"./fr-ca": 113,
	"./fr-ca.js": 113,
	"./fr-ch": 114,
	"./fr-ch.js": 114,
	"./fr.js": 115,
	"./fy": 116,
	"./fy.js": 116,
	"./gd": 117,
	"./gd.js": 117,
	"./gl": 118,
	"./gl.js": 118,
	"./gom-latn": 119,
	"./gom-latn.js": 119,
	"./he": 120,
	"./he.js": 120,
	"./hi": 121,
	"./hi.js": 121,
	"./hr": 122,
	"./hr.js": 122,
	"./hu": 123,
	"./hu.js": 123,
	"./hy-am": 124,
	"./hy-am.js": 124,
	"./id": 125,
	"./id.js": 125,
	"./is": 126,
	"./is.js": 126,
	"./it": 127,
	"./it.js": 127,
	"./ja": 128,
	"./ja.js": 128,
	"./jv": 129,
	"./jv.js": 129,
	"./ka": 130,
	"./ka.js": 130,
	"./kk": 131,
	"./kk.js": 131,
	"./km": 132,
	"./km.js": 132,
	"./kn": 133,
	"./kn.js": 133,
	"./ko": 134,
	"./ko.js": 134,
	"./ky": 135,
	"./ky.js": 135,
	"./lb": 136,
	"./lb.js": 136,
	"./lo": 137,
	"./lo.js": 137,
	"./lt": 138,
	"./lt.js": 138,
	"./lv": 139,
	"./lv.js": 139,
	"./me": 140,
	"./me.js": 140,
	"./mi": 141,
	"./mi.js": 141,
	"./mk": 142,
	"./mk.js": 142,
	"./ml": 143,
	"./ml.js": 143,
	"./mr": 144,
	"./mr.js": 144,
	"./ms": 146,
	"./ms-my": 145,
	"./ms-my.js": 145,
	"./ms.js": 146,
	"./my": 147,
	"./my.js": 147,
	"./nb": 148,
	"./nb.js": 148,
	"./ne": 149,
	"./ne.js": 149,
	"./nl": 151,
	"./nl-be": 150,
	"./nl-be.js": 150,
	"./nl.js": 151,
	"./nn": 152,
	"./nn.js": 152,
	"./pa-in": 153,
	"./pa-in.js": 153,
	"./pl": 154,
	"./pl.js": 154,
	"./pt": 156,
	"./pt-br": 155,
	"./pt-br.js": 155,
	"./pt.js": 156,
	"./ro": 157,
	"./ro.js": 157,
	"./ru": 158,
	"./ru.js": 158,
	"./sd": 159,
	"./sd.js": 159,
	"./se": 160,
	"./se.js": 160,
	"./si": 161,
	"./si.js": 161,
	"./sk": 162,
	"./sk.js": 162,
	"./sl": 163,
	"./sl.js": 163,
	"./sq": 164,
	"./sq.js": 164,
	"./sr": 166,
	"./sr-cyrl": 165,
	"./sr-cyrl.js": 165,
	"./sr.js": 166,
	"./ss": 167,
	"./ss.js": 167,
	"./sv": 168,
	"./sv.js": 168,
	"./sw": 169,
	"./sw.js": 169,
	"./ta": 170,
	"./ta.js": 170,
	"./te": 171,
	"./te.js": 171,
	"./tet": 172,
	"./tet.js": 172,
	"./th": 173,
	"./th.js": 173,
	"./tl-ph": 174,
	"./tl-ph.js": 174,
	"./tlh": 175,
	"./tlh.js": 175,
	"./tr": 176,
	"./tr.js": 176,
	"./tzl": 177,
	"./tzl.js": 177,
	"./tzm": 179,
	"./tzm-latn": 178,
	"./tzm-latn.js": 178,
	"./tzm.js": 179,
	"./uk": 180,
	"./uk.js": 180,
	"./ur": 181,
	"./ur.js": 181,
	"./uz": 183,
	"./uz-latn": 182,
	"./uz-latn.js": 182,
	"./uz.js": 183,
	"./vi": 184,
	"./vi.js": 184,
	"./x-pseudo": 185,
	"./x-pseudo.js": 185,
	"./yo": 186,
	"./yo.js": 186,
	"./zh-cn": 187,
	"./zh-cn.js": 187,
	"./zh-hk": 188,
	"./zh-hk.js": 188,
	"./zh-tw": 189,
	"./zh-tw.js": 189
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = '/tablets-pwa';


/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/weview_rond.5fb22a7.png";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(290)
  __webpack_require__(289)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(320),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bc3f2be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-437ef058",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(319),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34dfa8bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5daf6742",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.currentQuestion.data.sortCount), function(number) {
    return _c('v-layout', {
      key: number,
      attrs: {
        "row": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.currentQuestion.data.choices,
        "label": ("Mon choix N°" + number),
        "single-line": "",
        "bottom": ""
      },
      on: {
        "change": function($event) {
          _vm.selectChanged(number, $event)
        }
      },
      model: {
        value: (_vm.answers[number]),
        callback: function($$v) {
          _vm.$set(_vm.answers, number, $$v)
        },
        expression: "answers[number]"
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "placeholder": "Votre réponse ...",
      "multi-line": ""
    },
    model: {
      value: (_vm.answer),
      callback: function($$v) {
        _vm.answer = $$v
      },
      expression: "answer"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left pb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v("← retour")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "text-xs-left headline"
  }, [_vm._v("Administration")]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-subheader', [_vm._v("Actions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.reset($event)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Réinitialiser la tablette")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Cela effacera toutes les données")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1"
  }, [_vm._v("replay")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Merci de renseigner le mot de passe administrateur"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentQuestion.data.type === "verbatim") ? _c('verbatim', {
    ref: "verbatim",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "multiChoice") ? _c('multi-choice', {
    ref: "multiChoice",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "singleChoice") ? _c('single-choice', {
    ref: "singleChoice",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : (_vm.currentQuestion.data.type === "order") ? _c('order', {
    ref: "order",
    on: {
      "newAnswer": _vm.newAnswerChanged,
      "canValidate": _vm.canValidateChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canValidate) ? _c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v("\n    Continuer\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "update-alert"
    }
  }, [_c('a', {
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Nouvelle version de l'application disponible. Cliquez ici pour la télécharger.")])]), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "light": "",
      "overflow": "",
      "absolute": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("dashboard")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.tabletName) ? _c('span', [_vm._v(_vm._s(_vm.tabletName))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = false;
        _vm.connectionDialog = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("tablet_android")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(!_vm.tabletId || !_vm.token || _vm.authenticated === false) ? _c('span', [_vm._v(" Tablette non authentifiée")]) : _c('span', [_vm._v("Tablette authentifiée")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.update($event)
      }
    }
  }, [_c('v-list-tile-action', [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_c('v-icon', [_vm._v("warning")])], 1) : (_vm.isUpdating) ? _c('span', {
    staticClass: "loading-rotate"
  }, [_c('v-icon', [_vm._v("cached")])], 1) : _c('span', [_c('v-icon', [_vm._v("check_circle")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Status:\n            "), (_vm.online) ? _c('strong', [_vm._v("connecté")]) : _c('strong', [_vm._v("hors connexion")])]), _vm._v(" "), _c('v-list-tile-sub-title', [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_vm._v("Mises à jours nécessaires.")]) : (_vm.isUpdating) ? _c('span', [_vm._v("Mise à jour en cours...")]) : (_vm.online) ? _c('span', [_vm._v("Données à jour")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleShowMoreInMenu()
      }
    }
  }, [_c('v-list-tile-content', [(_vm.showMoreInMenu) ? _c('v-list-tile-title', [_vm._v("Réduire")]) : _c('v-list-tile-title', [_vm._v("Avancé")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.showMoreInMenu) ? _c('v-icon', [_vm._v("keyboard_arrow_up")]) : _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), (_vm.showMoreInMenu) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": !_vm.online
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendDiag()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("bug_report")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Envoyer un rapport\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": !_vm.online
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadApp()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Rafraichir l'application\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.goToAdmin()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Administration\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-tile-content', [_vm._v("\n          Version : " + _vm._s(_vm.version) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "blue top-toolbar",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Weview")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), ((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_vm._v("Mises à jours nécessaires.")]) : (_vm.isUpdating) ? _c('span', [_vm._v("Mise à jour en cours...")]) : (!_vm.online) ? _c('span', [_vm._v("Hors ligne")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.update($event)
      }
    }
  }, [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_c('v-icon', [_vm._v("warning")])], 1) : (_vm.isUpdating) ? _c('span', {
    staticClass: "loading-rotate"
  }, [_c('v-icon', [_vm._v("cached")])], 1) : (!_vm.online) ? _c('span', [_c('v-icon', [_vm._v("remove_circle")])], 1) : _c('span', [_c('v-icon', [_vm._v("check_circle")])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "width": "480"
    },
    model: {
      value: (_vm.confirmSendDiag),
      callback: function($$v) {
        _vm.confirmSendDiag = $$v
      },
      expression: "confirmSendDiag"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Envoyer un rapport")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Êtes-vous sûr de vouloir envoyer un rapport aux équipes Weview ?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.isSendingDiag) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmSendDiag = false
      }
    }
  }, [_vm._v("Non")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "color": "accent",
      "loading": _vm.isSendingDiag
    },
    nativeOn: {
      "click": function($event) {
        _vm.processSendDiag()
      }
    }
  }, [_vm._v("Envoyer")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "home pt-4"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [(!_vm.token || !_vm.tabletId || _vm.authenticated === false) ? [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": "true",
      "error": ""
    }
  }, [_vm._v("\n            Cette tablette n'est pas authentifiée\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "primary": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connectionDialog = true
      }
    }
  }, [_vm._v("Connecter la tablette")])] : (_vm.dataExpired) ? _c('div', [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": "true",
      "error": ""
    }
  }, [_vm._v("Les données de cette tablette ont expiré. Merci de connecter cette tablette à internet et/ou de retrouver du réseau afin de les mettre à jour")])], 1) : (_vm.dataExpired && _vm.isUpdating) ? _c('div', {
    staticClass: "loading text-xs-center"
  }, [_c('h4', {
    staticClass: "pb-4 pt-4"
  }, [_vm._v("Données en cours de synchronisation...")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  })], 1) : _c('navigation', {
    attrs: {
      "currentMenu": _vm.item
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "width": "480"
    },
    model: {
      value: (_vm.connectionDialog),
      callback: function($$v) {
        _vm.connectionDialog = $$v
      },
      expression: "connectionDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Quel est le code de connexion de cette tablette ?")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Code de connexion"
    },
    model: {
      value: (_vm.connectionCode),
      callback: function($$v) {
        _vm.connectionCode = $$v
      },
      expression: "connectionCode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connectionDialog = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connect($event)
      }
    }
  }, [_vm._v("Connexion")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation"
  }, [(_vm.currentMenu === "manager") ? _c('div', {
    staticClass: "choose-manager"
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Qui êtes-vous ?\n        ")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [(_vm.managers.length === 0 && _vm.isUpdating) ? _c('p', {
    staticClass: "text-xs-left pl-3"
  }, [_c('em', [_vm._v("Chargement...")])]) : (_vm.managers.length === 0 && !_vm.isUpdating) ? _c('p', {
    staticClass: "text-xs-left pl-3"
  }, [_c('em', [_vm._v("Pas de manager autorisé sur cette tablette")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.managers), function(manager) {
    return _c('span', {
      key: manager.id,
      on: {
        "click": function($event) {
          _vm.chooseManager(manager)
        }
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(manager.firstname) + " " + _vm._s(manager.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(manager.email))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentMenu === "survey") ? _c('div', {
    staticClass: "choose-survey"
  }, [(_vm.currentManager) ? _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    nativeOn: {
      "click": function($event) {
        _vm.goBackToManagerChoice($event)
      }
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), (_vm.currentManager.surveyStarts) ? _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Veuillez choisir une enquête dans la liste ci-dessous")]) : _c('p', [_vm._v("Pas d'enquête ouverte pour cet utilisateur")])], 1)]), _vm._v(" "), (_vm.currentManager.surveyStarts) ? _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.currentManager.surveyStarts), function(surveyStart) {
    return _c('span', {
      key: surveyStart.id,
      on: {
        "click": function($event) {
          _vm.chooseSurveyStart(surveyStart)
        }
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(surveyStart.survey.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enquête démarrée le " + _vm._s(_vm.moment(surveyStart.createdAt).format('DD/MM/YYYY')))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)], 1)
  })) : _vm._e()], 1)], 1) : _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', [_vm._v("Aucun manager selectionné")])], 1)])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentMenu === "participant") ? _c('div', {
    staticClass: "choose-participant"
  }, [(_vm.currentSurveyStart) ? _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left pb-0"
  }, [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    nativeOn: {
      "click": function($event) {
        _vm.goBackToSurveyChoice($event)
      }
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 mt-2 text-xs-center subheading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.currentManager.firstname) + " " + _vm._s(_vm.currentManager.lastname))]), _vm._v(", qui souhaitez-vous faire répondre ?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-3 mb-2"
  }, [_c('v-menu', {
    staticClass: "team-filter-menu",
    attrs: {
      "offset-y": ""
    }
  }, [(Object.keys(_vm.currentPossibleNodes).length > 2) ? _c('v-btn', {
    staticClass: "pa-1 pr-2",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Afficher les participants de : "), _c('em', [_vm._v(_vm._s(_vm.currentPossibleNodes[_vm.teamFilter]))]), _vm._v(" "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e(), _vm._v(" "), _c('v-list', _vm._l((_vm.currentPossibleNodes), function(label, node) {
    return _c('span', {
      key: node,
      staticClass: "team-filter-menu-item"
    }, [_c('v-list-tile', {
      attrs: {
        "disabled": _vm.teamFilter === node
      },
      on: {
        "click": function($event) {}
      },
      nativeOn: {
        "click": function($event) {
          _vm.teamFilter = node
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(label))])], 1), _vm._v(" "), _c('v-divider')], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.currentParticipants), function(participant) {
    return (participant.employee.id !== _vm.currentManager.id) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "disabled": participant.hasAnswered || participant.isDone
      },
      nativeOn: {
        "click": function($event) {
          _vm.chooseParticipant(participant)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(participant.employee.firstname) + " " + _vm._s(participant.employee.lastname))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(participant.node.label))])]), _vm._v(" "), (participant.employee.id === _vm.currentManager.id) ? _c('span', [_vm._v("Manager de: "), _c('em', [_vm._v(_vm._s(participant.node.label))])]) : ( false) ? _c('span', [_vm._v("Cet employé a reçu une invitation pour répondre")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [(participant.hasAnswered || participant.isDone) ? _c('v-icon', {
      staticClass: "green--text text--lighten-1"
    }, [_vm._v("check")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.nextMergedParticipants), function(info, nodeId) {
    return (!_vm.onTheFly || info.nbLeft > 0) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "disabled": info.nbLeft === 0
      },
      nativeOn: {
        "click": function($event) {
          _vm.chooseNextMergedParticipant(nodeId)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(info.node.label))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  " + _vm._s(info.nbDone) + "/" + _vm._s(info.nbTotal) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [(info.nbLeft === 0) ? _c('v-icon', {
      staticClass: "green--text text--lighten-1"
    }, [_vm._v("check")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.additionnalParticipants), function(participant) {
    return [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.chooseParticipant(participant)
        }
      }
    }, [_c('v-list-tile-avatar', [(participant.isAdditionnal) ? _c('v-icon', [_vm._v("person_add")]) : _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v("Membre de l'équipe: "), _c('em', [_vm._v(_vm._s(participant.node.label))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [(participant.node.nbEmployeesWOEmail === 0) ? _c('span', [_vm._v("\n                    Participant supplémentaire\n                  ")]) : (_vm.nextMergedParticipants[participant.node.id]) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.nextMergedParticipants[participant.node.id].nbDone) + "/" + _vm._s(_vm.nextMergedParticipants[participant.node.id].nbTotal) + "\n                  ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1)]
  })], 2)], 1)], 1) : _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "text-xs-left"
  }, [_c('div', [_c('v-btn', {
    staticClass: "ml-0 mb-4",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("← Précédent")]), _vm._v(" "), _c('p', [_vm._v("Aucune enquête selectionnée")])], 1)])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.currentQuestion.data.choices), function(choice) {
    return _c('v-checkbox', {
      key: choice,
      attrs: {
        "value": choice,
        "label": choice
      },
      model: {
        value: (_vm.answers),
        callback: function($$v) {
          _vm.answers = $$v
        },
        expression: "answers"
      }
    })
  }), _vm._v(" "), (_vm.currentQuestion.data.otherChoice) ? _c('v-checkbox', {
    attrs: {
      "label": _vm.currentQuestion.data.otherLabel,
      "value": _vm.currentQuestion.data.otherLabel
    },
    model: {
      value: (_vm.answers),
      callback: function($$v) {
        _vm.answers = $$v
      },
      expression: "answers"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answers.includes(_vm.currentQuestion.data.otherLabel)) ? _c('v-text-field', {
    staticStyle: {
      "margin-top": "-1.5rem",
      "margin-left": "2.3rem"
    },
    attrs: {
      "label": "Précisez",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer-screen"
  }, [(_vm.survey && _vm.participant && !_vm.submited) ? _c('div', {
    attrs: {
      "id": "wrapper-survey-answer"
    }
  }, [(_vm.survey.questions.length > 0 && _vm.currentQuestion === null) ? _c('div', [(_vm.survey.questions.length > 0 && _vm.currentQuestion === null) ? _c('div', [(_vm.survey.$scopQuestionnaire) ? _c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n          Bonjour,"), _c('br'), _c('br'), _vm._v("\n\n          Comme l'ensemble des sociétés coopératives, Acome, en tant que SCOP, doit obligatoirement effectuer l’audit coopératif afin de pouvoir obtenir son agrément ministériel."), _c('br'), _c('br'), _vm._v("\n\n          ARESCOP, l’Association de Révision des Sociétés Coopératives, mise en place par la Confédération Générale des SCOP, a été retenue pour conduire cette mission."), _c('br'), _c('br'), _vm._v("\n\n          Un des objectifs de la révision coopérative est d'apprécier votre perception de la vie coopérative et de son fonctionnement au sein d‘Acome."), _c('br'), _c('br'), _vm._v("\n\n          Dans ce cadre, nous adressons un questionnaire à l'ensemble des associés d’Acome. Cette enquête est ANONYME et a pour but de faire ressortir des éléments dominants et non des prises de positions individuelles. C'est donc en toute confiance que nous devrons travailler ensemble."), _c('br'), _c('br'), _vm._v("\n\n          Nous vous remercions de bien vouloir consacrer du temps à ce moment d’expression important dans la vie de votre coopérative et de contribuer ainsi à l'audit que nous entreprenons."), _c('br'), _c('br'), _vm._v("\n\n          En tant que salarié, si vous n’êtes pas encore associé, vous n’aurez pas accès aux questions de la Révision coopérative mais serez renvoyé directement à l’enquête relative à la Qualité de Vie au Travail (QVT)."), _c('br'), _c('br'), _vm._v("\n          Ce questionnaire peut comporter jusqu'à " + _vm._s(_vm.survey.questions.length) + " questions.\n        ")]) : _c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n          Bonjour, vous allez répondre à une enquête de façon anonyme."), _c('br'), _c('br'), _vm._v("\n          Cette enquête " + _vm._s(_vm.survey.scopQuestionnaire ? "peut comprter jusqu'à" : "comporte") + " " + _vm._s(_vm.survey.questions.length) + " questions et ne vous prendra que peu de temps."), _c('br'), _c('br'), _vm._v("\n          Nous comptons sur vous pour avoir une vision la plus objective possible."), _c('br'), _c('br'), _vm._v("\n          Cliquez sur \"Commencer\" quand vous êtes prêt.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.start($event)
      }
    }
  }, [_vm._v("Commencer")])], 1)]) : (_vm.currentQuestion) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "140px",
      "right": "0",
      "bottom": "0",
      "left": "0",
      "text-align": "center"
    }
  }, [_c('div', [(_vm.getCategory(_vm.currentQuestion)) ? _c('div', {
    staticClass: "category"
  }, [_vm._v("\n          " + _vm._s(_vm.getCategory(_vm.currentQuestion)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "question-label",
    style: (("margin-top: " + (_vm.currentQuestion.questionnaire ? "40" : "100") + "px;"))
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.label) + "\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "question-sub-label"
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.subLabel) + "\n        ")])]), _vm._v(" "), (_vm.currentQuestion.questionnaire) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-center": ""
    }
  }, [_c('v-flex'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "text-xs-center": ""
    }
  }, [_c('question', {
    on: {
      "next": _vm.nextQuestion
    }
  })], 1), _vm._v(" "), _c('v-flex')], 1)], 1) : _c('div', [_c('div', {
    staticClass: "pb-4 mb-4 survey-answer-happiness-wrapper"
  }, [_c('div', {
    staticClass: "survey-answer-happiness"
  }, [_c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-1', {
      selected: _vm.currentScore === 0
    }],
    on: {
      "click": function($event) {
        _vm.answer(0)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  }), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("sentiment_dissatisfied")])], 1), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-2', {
      selected: _vm.currentScore === 1
    }],
    on: {
      "click": function($event) {
        _vm.answer(1)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-3', {
      selected: _vm.currentScore === 2
    }],
    on: {
      "click": function($event) {
        _vm.answer(2)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-4', {
      selected: _vm.currentScore === 3
    }],
    on: {
      "click": function($event) {
        _vm.answer(3)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  })]), _vm._v(" "), _c('div', {
    class: ['happiness-btn', 'survey-answer-happiness-5', {
      selected: _vm.currentScore === 4
    }],
    on: {
      "click": function($event) {
        _vm.answer(4)
      }
    }
  }, [_c('div', {
    staticClass: "halo"
  }), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("sentiment_satisfied")])], 1)])]), _vm._v(" "), (!_vm.currentQuestion.isVerbatim) ? _c('div', {
    staticClass: "answer-confirm pt-4 mt-4"
  }, [_c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    style: ({
      opacity: _vm.currentScore === null ? 0 : 1,
    }),
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmAnswer($event)
      }
    }
  }, [_vm._v("Valider")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.currentQuestion.isVerbatim && _vm.currentScore !== null) ? _c('div', {
    staticClass: "survey-answer-verbatim"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.currentQuestion.verbatimHelper || "Apportez des précisions sur votre réponse ici...",
      "multi-line": ""
    },
    model: {
      value: (_vm.currentVerbatim),
      callback: function($$v) {
        _vm.currentVerbatim = $$v
      },
      expression: "currentVerbatim"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.maxVerbatimLength) + " caractères maximum\n          "), (_vm.currentVerbatim.length <= 250) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(" + _vm._s(_vm.maxVerbatimLength - _vm.currentVerbatim.length) + " restant)")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.currentVerbatim.length) + " utilisés)")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "survey-answer-verbatim-button-wrapper"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": "",
      "disabled": _vm.currentVerbatim.length > _vm.maxVerbatimLength
    },
    nativeOn: {
      "click": function($event) {
        _vm.answerVerbatim($event)
      }
    }
  }, [_vm._v("Valider")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "answer-footer-wrapper"
  }, [_c('div', {
    staticClass: "answer-footer progress"
  }, [_vm._v("\n          " + _vm._s(_vm.currentQuestion.index + 1) + "/" + _vm._s(_vm.survey.questions.length) + "\n        ")])])]) : _vm._e()]) : (_vm.submited) ? _c('div', [_c('div', {
    staticClass: "content-body welcome"
  }, [_vm._v("\n        Merci d'avoir répondu ! Vous pouvez passer la tablette à la personne suivante après avoir cliqué sur \"Terminer\", à bientôt !\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "answers-buttom elevation-0 deep-purple accent-2 white--text",
    attrs: {
      "large": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToHome($event)
      }
    }
  }, [_vm._v("Terminer")])], 1)]) : _c('div', [_vm._v("Pas de données de particpant ni de diagnostic")])])
},staticRenderFns: []}

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.currentQuestion.data.choices), function(choice) {
    return _c('v-radio', {
      key: choice,
      attrs: {
        "label": choice,
        "value": choice
      },
      model: {
        value: (_vm.answer),
        callback: function($$v) {
          _vm.answer = $$v
        },
        expression: "answer"
      }
    })
  }), _vm._v(" "), (_vm.currentQuestion.data.otherChoice) ? _c('v-radio', {
    attrs: {
      "label": _vm.currentQuestion.data.otherLabel,
      "value": _vm.currentQuestion.data.otherLabel
    },
    model: {
      value: (_vm.answer),
      callback: function($$v) {
        _vm.answer = $$v
      },
      expression: "answer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer === _vm.currentQuestion.data.otherLabel) ? _c('v-text-field', {
    staticStyle: {
      "margin-top": "-1.5rem",
      "margin-left": "2.3rem"
    },
    attrs: {
      "label": "Précisez",
      "required": ""
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      online: _vm.online
    },
    attrs: {
      "id": "app",
      "light": ""
    }
  }, [_c('main', [_c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(303),
      "alt": "Vue.js PWA"
    }
  })]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: []}

/***/ })

},[228]);


// WEBPACK FOOTER //
// static/js/app.41a16b9740f752586f0f.js